import { BaseException } from "@/exceptions/base-exception.exception"
import { ExceptionWeights } from "@/enums/exceptions/exception-weights"
import { InstructionFeedbackActivity } from "@/models/instruction-feedback-activity.model"

export class FeedbackActivityOutOfWorkPeriodException extends BaseException {
  exceptionId = "INSTRUCTION_FEEDBACK_ACTIVITY_OUT_OF_WORK_PERIOD"
  title = "Let op, niet opgeslagen!"
  weight = ExceptionWeights.ERROR

  private readonly violatingFeedbackActivities?: InstructionFeedbackActivity[]

  constructor(violatingFeedbackActivities?: InstructionFeedbackActivity[]) {
    super()
    if (violatingFeedbackActivities) {
      this.violatingFeedbackActivities = violatingFeedbackActivities.map(
        (activity) => new InstructionFeedbackActivity(activity)
      )
    }
  }

  public getMessage(): string {
    const { violatingFeedbackActivities } = this
    if (violatingFeedbackActivities) {
      if (violatingFeedbackActivities.length === 1) {
        const feedbackActivity = violatingFeedbackActivities[0]
        return `De werkzaamheden ${feedbackActivity.getTypeString()} van ${feedbackActivity.timeStart?.format("HH:mm")} uur tot ${feedbackActivity.timeEnd?.format("HH:mm")} uur vallen buiten je dienst.`
      }

      return `Deze werkzaamheden vallen buiten je dienst:
    ${violatingFeedbackActivities
      .map(
        (feedbackActivity) =>
          `- ${feedbackActivity.getTypeString()} ${feedbackActivity.timeStart?.format("HH:mm")} uur tot ${feedbackActivity.timeEnd?.format("HH:mm")} uur`
      )
      .join("\n")}`
    }
    return "Deze werkzaamheden vallen buiten je dienst. Pas eerst je diensttijden aan."
  }
}
